import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton, CustomInput } from "components";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";
import {
	normalizeAll,
	onlyAlphanumericAndSpecialCharacters,
	validateWhenUseAThirdPartyForFulfillment,
} from "validators/validation";

import styles from "./formSections.module.scss";

const BusinessUnderwritingInfoPartTwo = ({ useThirdPartyFulfillment }) => (
	<>
		<Row>
			<Col lg={12} className="mt-2">
				<div className={`${styles.addressTitle} mb-4`}>
					Recurring Payments?
				</div>
				<div className={styles.wrappRadio}>
					<Field
						component={RadioButton}
						value="true"
						className={styles.radioButton}
						name="recurringPayments"
						label="Yes"
						type="radio"
						id="yesRecurringPayments"
					/>
					<Field
						component={RadioButton}
						value="false"
						className={styles.radioButton}
						name="recurringPayments"
						label="No"
						type="radio"
						id="noRecurringPayments"
					/>
				</div>
			</Col>
		</Row>
		<Row>
			<Col lg={12} className="mt-2">
				<div className={`${styles.addressTitle} mb-4`}>
					Do You Use a Third Party for Fulfillment?
				</div>
				<div className={styles.wrappRadio}>
					<Field
						component={RadioButton}
						value="true"
						className={styles.radioButton}
						name="doYouUseAThirdPartyForFulfillment"
						label="Yes"
						type="radio"
						id="yesThirdParty"
					/>
					<Field
						component={RadioButton}
						value="false"
						className={styles.radioButton}
						name="doYouUseAThirdPartyForFulfillment"
						label="No"
						type="radio"
						id="noThirdParty"
					/>
				</div>
			</Col>
		</Row>
		<Row>
			<Col lg={5}>
				<Field
					component={CustomInput}
					validate={validateWhenUseAThirdPartyForFulfillment}
					disabled={!useThirdPartyFulfillment}
					name="whoDoYouUseAThirdPartyForFulfillment"
					normalizeOnBlur={trimNormalizer}
					normalize={normalizeAll([
						onlyAlphanumericAndSpecialCharacters,
						trimMidSentenceNormalizer,
					])}
					label="Who?"
					labelClassName="flex-basis-100"
				/>
			</Col>
		</Row>
		<Row>
			<Col>
				<div className={`${styles.addressTitle} mb-4`}>
					Site Inspection Completed By
				</div>
				<div className={styles.wrappRadio}>
					<Field
						component={RadioButton}
						value="aurora"
						className={styles.item}
						name="siteInspectionBy"
						label="Aurora"
						type="radio"
						id="siteInspectionBy_aurora"
					/>
					<Field
						component={RadioButton}
						value="agent"
						className={styles.item}
						name="siteInspectionBy"
						label="Agent"
						type="radio"
						id="siteInspectionBy_agent"
					/>
				</div>
			</Col>
		</Row>
	</>
);

export default memo(BusinessUnderwritingInfoPartTwo);
